<template>
  <div class="detail">
    <div
      class="text"
      v-html="htmlData"
      :class="{ show_all: !isHelp }"
      @click="previewImage"
    ></div>
    <div class="footer" v-if="isHelp">
      <van-divider>这条信息对您有帮助吗</van-divider>
      <div class="like">
        <div class="left" @click="clickHelp(false)">
          <i class="no-help" v-if="selectFalse" />
          <i class="no-gary" v-else />
          <span>没帮助</span>
        </div>
        <div class="right" @click="clickHelp(true)">
          <i class="good-job" v-if="selectTrue" />
          <i class="good-gary" v-else />
          <span>有帮助</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getHelpViewData, getIsHelp } from "../../services/request.js";
import { Divider, ImagePreview } from "vant";

export default {
  data() {
    return {
      htmlData: "",
      selectFalse: false,
      selectTrue: false,
      isHelp: this.$route.query.isHelp,
      id: undefined
    };
  },
  components: {
    "van-divider": Divider
  },
  computed: {
    // 默认开启；入口 URL 携带 imagePreview=0 时关闭。
    enableImagePreview() {
      return this.$route.query.imagePreview !== "0";
    }
  },
  created() {
    this.id = parseFloat(this.$route.query.id);
    this.getHelpViewData();
  },
  methods: {
    clickHelp(flag) {
      if (flag) {
        this.selectTrue = !this.selectTrue;
        this.selectFalse = false;
      } else {
        this.selectFalse = !this.selectFalse;
        this.selectTrue = false;
      }
      this.getIsHelp(flag);
    },
    async getHelpViewData() {
      try {
        const res = await getHelpViewData(this.$route.query.id);
        if (res && res.Data) {
          this.htmlData = res.Data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getIsHelp(flag) {
      try {
        const params = {
          canHelp: flag,
          state: this.selectTrue || this.selectFalse ? 1 : -1,
          id: this.$route.query.id
        };
        const res = await getIsHelp(params);
        console.log(res);
      } catch (e) {
        console.log(e);
      }
    },
    previewImage(event) {
      if (!this.enableImagePreview) {
        return;
      }

      const target = event.target;
      if (!target || target.tagName !== "IMG") {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      // 富文本由 v-html 注入，内部图片无法直接绑定事件，这里统一收集当前内容里的图片。
      const imageNodes = Array.prototype.slice.call(
        this.$el.querySelectorAll(".text img")
      );
      const images = imageNodes
        .map(
          img =>
            img.currentSrc ||
            img.src ||
            img.getAttribute("data-src") ||
            img.getAttribute("src")
        )
        .filter(Boolean);

      if (!images.length) {
        return;
      }

      ImagePreview({
        images,
        startPosition: Math.max(imageNodes.indexOf(target), 0)
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    if (!to.query.isHelp) {
      document.title = "\u200E";
    } else {
      document.title = "帮助中心";
    }
    next();
  }
};
</script>
<style lang="scss">
.detail {
  height: 100%;
  max-height: 100%;

  .text {
    height: calc(100% - 68px);
    overflow: scroll;
    padding: 0 16px;
  }
  img {
    width: 100%;
  }
  .show_all {
    height: 100%;
  }
  .footer {
    height: 68px;
    .like {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 40px;
      width: 100%;
      .left {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50%;
        height: 100%;
        text-align: center;
        .no-help {
          background: url("../../assets/zan-color.png");
          width: 25px;
          height: 25px;
          display: inline-block;
          background-size: 100% 100%;
          margin-right: 5px;
          transform: rotate(-180deg);
        }
        .no-gary {
          @extend .no-help;
          background: url("../../assets/zan-gary.png");
          background-size: 100% 100%;
        }
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50%;
        height: 100%;
        .good-job {
          background: url("../../assets/zan-color.png");
          width: 25px;
          height: 25px;
          display: inline-block;
          background-size: 100% 100%;
          margin-right: 5px;
        }
        .good-gary {
          @extend .good-job;
          background: url("../../assets/zan-gary.png");
          background-size: 100% 100%;
        }
      }
    }
  }
  .van-divider {
    margin: 0;
    height: 20px;
  }
}
</style>
